import axios from "axios";
import {uts, redirectWithoutLottie, getSystemVersion} from './functions';
import {Languages} from './languages.class';
import { Device } from '@capacitor/device';

const majorVersion = Number.parseInt(process.env.VUE_APP_MAJOR_VERSION);
const loadConfigFromRemote = !!Number.parseInt(process.env.VUE_APP_LOAD_CONFIG_FROM_REMOTE);
const forceTestAPI = !!Number.parseInt(process.env.VUE_APP_FORCE_TEST_API);

window.forceTestAPI = forceTestAPI;
console.log('forceTestAPI', forceTestAPI)

export async function getPlatform() {
    let osKey = '';
    let forceAndroid = false;
    const deviceInfo = await Device.getInfo();
    switch (deviceInfo.platform) {
        case 'ios':
        case 'android':
        case 'web':
            osKey = deviceInfo.platform;
            break;

        default:
            forceAndroid = true;
            break;
    }

    if (forceAndroid) {
        osKey = 'android';
    }

    return osKey;
}

export function deleteStorageByVersion() {
    const storedMajorVersion = localStorage.getItem('storedMajorVersion');
    if (storedMajorVersion == null || parseInt(storedMajorVersion) <= 0) {
        localStorage.clear();
        localStorage.setItem('storedMajorVersion', majorVersion);
        redirectWithoutLottie('/');
        return;
    }

    if (parseInt(storedMajorVersion) < majorVersion) {
        localStorage.clear();
        localStorage.setItem('storedMajorVersion', majorVersion);
        redirectWithoutLottie('/');
        return;
    }
}

export async function updateConfigFromRemote() {
    if (!loadConfigFromRemote) {
        return false;
    }

    const platform = await getPlatform();
    const remoteConfigCache = localStorage.getItem('remoteConfigCache');
    const remoteConfigLastUpdated = localStorage.getItem('remoteConfigLastUpdated');
    if (remoteConfigCache == null || remoteConfigLastUpdated == 0 || (uts() - remoteConfigLastUpdated) >= 21600) { //Read remote config if necessary
        let apiURL = 'https://mobileapi.matrixhu.com/site/MatrixNewUI/module/mobileApi/type/getConfig';
        if (getSystemVersion() != 'hu') {
            apiURL += `/systemVersion/${getSystemVersion()}`;
            //apiURL += ``;
        }
        if (forceTestAPI) {
            apiURL += '/forceTestAPI/1';
        }
        const configConverted = JSON.stringify(config);

        await axios.post(apiURL, {majorVersion: majorVersion, osKey: platform}, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
              if (typeof response.data != 'undefined' && response.data != null && typeof response.data.status != 'undefined' && response.data.status == 'success') {
                localStorage.setItem('remoteConfigCache', JSON.stringify(response.data));
                localStorage.setItem('remoteConfigLastUpdated', uts());
              } else {
                localStorage.setItem('remoteConfigCache', configConverted);
                localStorage.setItem('remoteConfigLastUpdated', uts());
              }

              redirectWithoutLottie('/');
          }).catch(function () {
                localStorage.setItem('remoteConfigCache', configConverted);
                localStorage.setItem('remoteConfigLastUpdated', uts());

                redirectWithoutLottie('/');
        });

        return false;
    } else {
        const remoteConfigCacheParsed = JSON.parse(remoteConfigCache);
        if (typeof remoteConfigCacheParsed.handledKeys != 'undefined') {
            for (const configKey of remoteConfigCacheParsed.handledKeys) {
                const keyParsed = configKey.split('_');

                if (typeof config[keyParsed[0]] != 'undefined'
                && typeof config[keyParsed[0]][keyParsed[1]] != 'undefined'
                && typeof remoteConfigCacheParsed[keyParsed[0]] != 'undefined'
                && typeof remoteConfigCacheParsed[keyParsed[0]][keyParsed[1]] != 'undefined') {
                    config[keyParsed[0]][keyParsed[1]] = remoteConfigCacheParsed[keyParsed[0]][keyParsed[1]];
                }
            }
        }
    }
}

export function getConfig(key) {
    if (typeof key == 'undefined') {
        return config;
    }

    return config[key];
}

export function generateURL(action, func) {
  if (typeof func == 'undefined') {
    func = '';
  }

  let url = '';
  let languagesClass = new Languages;
  let languageId = languagesClass.getSelectedLanguageId();

  switch (action) {
    case 'login':
      url = config.api.loginURL;
      break;
    case 'dashboard':
      url = config.api.dashboardURL;
       url = `https://biromarcell.service01.dunahousedev.hu/site/service/module/api/key/${DASHBOARD_API_KEY}/mode/dashboard/`;
      if (func != '') {
        url += `function/${func}`;
      }
      break;

    case 'contractSearch':
      url = config.api.contractSearchURL;
      break;

    case 'contractCount':
      url = config.api.contractCountURL;
      break;

    case 'createNewAIAgentThread':
    case 'modifyThread':
    case 'sendAIAgentMessage':
    case 'waitingToAnswer':
    case 'loadAiAgents':
      url = `${config.api.aiAssistantURL}mode/${action}`;
      break;

    default:
      url = `${config.api.baseURL}type/${action}`;
      url += `/lang/${languageId}`;
      break;
  }

  return url;
}

//const MATRIX_URL = (forceTestAPI) ? 'https://bohunkazsolt.vision.dunahousedev.hu' : 'https://mobileapi.matrixhu.com';

let MATRIX_URL = 'https://mobileapi.matrixhu.com';
if (forceTestAPI) {
    if ((getSystemVersion() == 'pl')) {
        MATRIX_URL = 'https://polish-dev.matrixhu.com';
    } else {
        // MATRIX_URL = 'https://szunyogdavid.vision.dunahousedev.hu';
        // MATRIX_URL = 'https://biromarcell.vision.dunahousedev.hu';
        MATRIX_URL = 'https://biromarcell.vision.dunahousedev.hu';
        // MATRIX_URL = 'https://vision.dunahousedev.hu';
    }
    // MATRIX_URL = 'https://vision.dunahousedev.hu';
} else {
    if ((getSystemVersion() == 'pl')) {
        MATRIX_URL = 'https://matrix.metrohouse.pl';
    } else {
        MATRIX_URL = 'https://mobileapi.matrixhu.com';
    }
}

const DASHBOARD_URL = (getSystemVersion() == 'pl') ? 'https://service01.backupsrv-pl.hu' : 'https://service01.matrixhu.com';
const DASHBOARD_API_KEY = (getSystemVersion() == 'pl') ? '5K5sJxS2kOys0vez9Qkdx95RmrWfSnNg8JzYxJaQ0sv8nYqa2kQwHnoxflLCBlOmNAEd29' : 'YYFuXyUrpM2k8d6xsavW0oG4l91v5gcD';
const CONTRACT_SEARCH_API_KEY = 'L8E3T17SK6EcmQzgOqTlr2JYoReGyJs3';

let ASSISTANT_URL = 'https://aichat.matrixhu.com';
let ASSISTANT_API_KEY = (getSystemVersion() == 'pl') ? '1URtSVhKoWXxuN3UP1lzqfVYZS79MuDXUDb35M9FbBVZImiPY1FRrb' : 'q2v1l4PvbCVzJhIjZVGlBdS7NsPCvhqMJyH5iDEm3YOvl7gGqfJPsP';
if (forceTestAPI) {
  ASSISTANT_URL = 'https://bohunkazsolt.aiassistant.dunahousedev.hu';
  ASSISTANT_API_KEY = (getSystemVersion() == 'pl') ? 'u3KtDv1MjJ3YrV80Lnc3TKoThz7rL2pP7oV7sSMLrySiBm6xUwI7zf' : 'lC5zoh6gOXVl9M21RCRbqJWlvaxNpz8CqVml1jQDhbesQ1MBZqDACv';
}

export let config = {
    api: {
        baseURL: `${MATRIX_URL}/module/mobileApi/`,
        loginURL: `${MATRIX_URL}/module/mobileApi/type/login`,
        dashboardURL: `${DASHBOARD_URL}/site/service/module/api/key/${DASHBOARD_API_KEY}/mode/dashboard/`,
        contractSearchURL: `${MATRIX_URL}/site/MatrixNewUI/module/cronJobApi/type/apiConnection/apiKey/${CONTRACT_SEARCH_API_KEY}/api/MX_contractSearch/filter/search/`,
        contractCountURL: `${MATRIX_URL}/site/MatrixNewUI/module/cronJobApi/type/apiConnection/apiKey/${CONTRACT_SEARCH_API_KEY}/api/MX_contractSearch/filter/count/`,
        matrixURL: MATRIX_URL,
        aiAssistantURL: `${ASSISTANT_URL}/site/assistant/module/ai/apiKey/${ASSISTANT_API_KEY}/`
    },
    app: {
        loginValidInSeconds: 21600,
        mainVersion: 1,
        subVersion: Number.parseInt(process.env.VUE_APP_SUB_VERSION),
        majorVersion: majorVersion,
    },
    propertySearch: {
        itemPerPage: 15,
        heightLatencyToLoadNextItems: 600
    },
    contractForm: {
        mandatoryFields: {
            typeOfListing: {},
            contractType: {},
            targetPrice: {zeroEnabled: true},
            advertisingPrice: {zeroEnabled: false, onlyIfDuo: true},
            // advertisingPriceValidFromDate: {zeroEnabled: false, onlyIfDuo: true},
            // advertisingPriceAfterDate: {zeroEnabled: true, onlyIfDuo: true},
            // advertisingPriceAfterDateCurrency: {zeroEnabled: true, onlyIfDuo: true},
            contractCancelFee: {zeroEnabled: false, onlyIfDuo: true},
            limitPrice: {zeroEnabled: true},
            minimumTimeOfTakingPossession: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            maximumTimeOfTakingPossession: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            minimumAmountOfFirstPurchasePrice: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            minimumAmountOfFirstPurchasePriceRate: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            commissionRate: {zeroEnabled: true, onlyIfNotDuo: true},
            minimumCommission: {zeroEnabled: true, onlyIfNotDuo: true},
            duoCommissionRate: {onlyIfDuo: true},
            minimumCommissionDuo: {onlyIfDuo: true},
            typeOfProperty: {zeroEnabled: false},
            structureOfTheBuilding: {zeroEnabled: false, onlyIfNotPlot: true},
            zipCode: {zeroEnabled: false},
            cityId: {zeroEnabled: false},
            street: {zeroEnabled: false},
            houseNumber: {zeroEnabled: false},
            heatingType: {zeroEnabled: false, onlyIfNotPlot: true},
            energyRating: {zeroEnabled: false, onlyIfNotPlot: true},
            clientTypeId: {zeroEnabled: false},
            clientTitleId: {zeroEnabled: false},
            lastName: {zeroEnabled: false, onlyIfPersonal: true},
            firstName: {zeroEnabled: false, onlyIfPersonal: true},
            birthDate: {zeroEnabled: true, onlyIfPersonal: true},
            birthPlace: {zeroEnabled: false, onlyIfPersonal: true},
            mothersName: {zeroEnabled: false, onlyIfPersonal: true},
            phonePart1: {zeroEnabled: false},
            phonePart2: {zeroEnabled: false},
            phonePart3: {zeroEnabled: false},
            email: {zeroEnabled: false},
            companyName: {zeroEnabled: false, onlyIfFirm: true},
            companyShortName: {zeroEnabled: false, onlyIfFirm: true},
            taxNumberCompany: {zeroEnabled: false, onlyIfFirm: true},
            tradeRegNumber: {zeroEnabled: false, onlyIfFirm: true},
            representativeName: {zeroEnabled: false, onlyIfFirm: true},
            representativeTitle: {zeroEnabled: false, onlyIfFirm: true},
            representativeAddress: {zeroEnabled: false, onlyIfFirm: true},
            representativeBirthDate: {zeroEnabled: false, onlyIfFirm: true},
            representativeBirthPlace: {zeroEnabled: false, onlyIfFirm: true},
            representativeMothersName: {zeroEnabled: false, onlyIfFirm: true},
            representativeClientNationalityId: {zeroEnabled: false, onlyIfFirm: true},
            authorizedName: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedAddress: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedBirthDate: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedBirthPlace: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedMothersName: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedClientNationalityId: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedTypeOfCard: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedNumberOfCard: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedPhonePart1: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedPhonePart2: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedPhonePart3: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            authorizedEmail: {zeroEnabled: false, onlyIfFirmAuthorized: true},
            // TODO: GIT - 721 - Temporary disabled
            // deliveryAgent: {zeroEnabled: false, onlyIfFirm: true},
            companyMainActivity: {zeroEnabled: false, onlyIfFirm: true},
            // deliveryAgentDocumentType: {zeroEnabled: false, onlyIfFirm: true},
            // deliveryAgentDocumentNumber: {zeroEnabled: false, onlyIfFirm: true},
            startDateOfExclusivity: {zeroEnabled: false, onlyIfPremium: true},
            exclusiveContractPeriod: {zeroEnabled: false, onlyIfPremium: true},
            duoContractPeriod: {zeroEnabled: false, onlyIfDuo: true},
            commissionRateExclusive: {zeroEnabled: false, onlyIfPremium: true},
            minimumCommissionExclusive: {zeroEnabled: false, onlyIfPremium: true},
            servicePackageFee: {zeroEnabled: false, onlyIfPremium: true},
            typeOfCard: {zeroEnabled: false, onlyIfPersonal: true},
            numberOfCard: {zeroEnabled: false, onlyIfPersonal: true},
            startOfListing: {zeroEnabled: true},
            endOfListing: {zeroEnabled: true, onlyIfNotundefinedPeriod: true},
            prominentPublicFigureId: {onlyIfOwnerAndPersonal: true},
            foreignAddress: {onlyIfIsForeignAddress: true},
            parcelNumber: {onlyIfIsForeignAddress: true},
            client_foreignAddress: {onlyIfClientIsForeignAddress: true},
            commissionRateStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            minimumCommissionStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            penaltyStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            ownership: {zeroEnabled: false, onlyIfOwner: true},
        },
        mandatoryFieldsPL: {
            depositAmount: {onlyIfRent: true},
            soonestMovingDate: {onlyIfRent: true},
            minRentTime: {onlyIfRent: true},
            typeOfListing: {},
            contractType: {},
            placeOfSign: {},
            typeOfOwnership: {onlyIfNotPlot: true},
            contractWasConcluded: {},
            landRegisterNumber: {landRegister: true},
            targetPrice: {zeroEnabled: true},
            limitPrice: {zeroEnabled: true},
            brokerAgreementTerminationPeriodMonths: {},
            // minimumTimeOfTakingPossession: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            // maximumTimeOfTakingPossession: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            minimumAmountOfFirstPurchasePrice: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            minimumAmountOfFirstPurchasePriceRate: {zeroEnabled: true, onlyIfNotRent: true, notAll: true},
            commissionRate: {zeroEnabled: true, onlyIfFieldEmpty: "minimumCommission"},
            commissionRateGross: {zeroEnabled: true, onlyIfFieldEmpty: "minimumCommissionGross"},
            minimumCommission: {zeroEnabled: true, onlyIfFieldEmpty: "commissionRate"},
            minimumCommissionGross: {zeroEnabled: true, onlyIfFieldEmpty: "commissionRateGross"},
            typeOfProperty: {zeroEnabled: false},
            // structureOfTheBuilding: {zeroEnabled: false, onlyIfNotPlot: true},
            zipCode: {zeroEnabled: false},
            cityId: {zeroEnabled: false},
            street: {zeroEnabled: false},
            // marketingDescription: {zeroEnabled: true},
            // headerDescription: {zeroEnabled: false},
            houseNumber: {uniqueFilter: true},
            parcelNumber: {uniqueFilter: true},
            // heatingType: {zeroEnabled: false, onlyIfNotPlot: true},
            clientTypeId: {zeroEnabled: false},
            clientTitleId: {zeroEnabled: false},
            lastName: {zeroEnabled: false, onlyIfPersonal: true},
            firstName: {zeroEnabled: false, onlyIfPersonal: true},
            birthDate: {zeroEnabled: true, onlyIfPersonal: true},
            // birthPlace: {zeroEnabled: false, onlyIfPersonal: true},
            // mothersName: {zeroEnabled: false, onlyIfPersonal: true},
            phonePart1: {zeroEnabled: false},
            phonePart2: {zeroEnabled: false},
            email: {zeroEnabled: false},
            intendedPurposeOfTheTransaction: {zeroEnabled: false, onlyIfNotRent: true, notAll: true},
            // fundsOriginStatement: {zeroEnabled: false},
            riskLevel: {zeroEnabled: false, onlyIfNotRent: true, notAll: true},
            companyName: {zeroEnabled: false, onlyIfFirm: true},
            companyShortName: {zeroEnabled: false, onlyIfFirm: true},
            taxNumberCompany: {zeroEnabled: false, onlyIfFirm: true},
            tradeRegNumber: {zeroEnabled: false, onlyIfFirm: true},
            representativeName: {zeroEnabled: false, onlyIfFirm: true},
            representativeTitle: {zeroEnabled: false, onlyIfFirm: true},
            representativeAddress: {zeroEnabled: false, onlyIfFirm: true},
            representativeBirthDate: {zeroEnabled: false, onlyIfFirm: true},
            representativeBirthPlace: {zeroEnabled: false, onlyIfFirm: true},
            representativeMothersName: {zeroEnabled: false, onlyIfFirm: true},
            representativeClientNationalityId: {zeroEnabled: false, onlyIfFirm: true},
            startDateOfExclusivity: {zeroEnabled: false, onlyIfPremium: true, notNeedComfortContract: true},
            exclusiveContractPeriod: {zeroEnabled: false, onlyIfPremium: true},
            commissionRateExclusive: {zeroEnabled: false, onlyIfPremium: true, onlyIfFieldEmpty: "minimumCommissionExclusive"},
            commissionRateExclusiveGross: {zeroEnabled: false, onlyIfPremium: true, onlyIfFieldEmpty: "minimumCommissionExclusiveGross"},
            minimumCommissionExclusive: {zeroEnabled: false, onlyIfPremium: true, onlyIfFieldEmpty: "commissionRateExclusive"},
            minimumCommissionExclusiveGross: {zeroEnabled: false, onlyIfPremium: true, onlyIfFieldEmpty: "commissionRateExclusiveGross"},
            penaltyPremiumOrComfort: {zeroEnabled: true, notAll: true, onlyIfPremium: true},
            // servicePackageFee: {zeroEnabled: false, onlyIfPremium: true},
            typeOfCard: {zeroEnabled: false, onlyIfPersonal: true},
            numberOfCard: {zeroEnabled: false, onlyIfPersonal: true},
            startOfListing: {zeroEnabled: true},
            endOfListing: {zeroEnabled: true, onlyIfNotundefinedPeriod: true},
            // prominentPublicFigureId: {onlyIfOwnerAndPersonal: true},
            foreignAddress: {onlyIfIsForeignAddress: true},
            client_foreignAddress: {onlyIfClientIsForeignAddress: true},
            commissionRateStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            minimumCommissionStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            penaltyStandardPlus: {zeroEnabled: false, onlyIfStandardPlus: true},
            // ownership: {zeroEnabled: false, onlyIfOwner: true},
            realClientTitleId: {zeroEnabled: false},
            // proxyRealClientTitleId: {zeroEnabled: false, proxyClient: true},
            proxyLastName: {zeroEnabled: false, proxyClient: true},
            proxyFirstName: {zeroEnabled: false, proxyClient: true},
            proxyPhonePart1: {zeroEnabled: false, proxyClient: true},
            proxyPhonePart2: {zeroEnabled: false, proxyClient: true},
            proxyTypeOfCard: {zeroEnabled: false, proxyClient: true},
            proxyNumberOfCard: {zeroEnabled: false, proxyClient: true},
            proxyEmail: {zeroEnabled: false, proxyClient: true}
        },
    },
    images: {
        dir: 'stored-images',
    },
    properties: {
        searchPriceMax: 5000,
        searchSizeMax: 1000000,
        searchMinRoomsNumberMax: 20
    },
    properties_pl: {
        searchPriceMax: 60000,
        searchSizeMax: 1000000,
        searchMinRoomsNumberMax: 20
    }
}